import React, { useEffect, useState } from "react";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";
import useHttp from '../../../hook/use-http';
import { API_URL_MAIN } from '../../../constants/driveglobalfilterinitalstates_bus';
import './CustomSelect_Bus.css'
import { decodeToken } from "react-jwt";
import { useLocation } from 'react-router-dom';

const CustomSelect_Bus = (props) => {
  let location = useLocation();
  let path_check = location.pathname;
  const lastSegment = path_check.split("/").pop();

  const tokenNew = JSON.parse(sessionStorage.user);
  let decodedToken = decodeToken(tokenNew.token);
  const city_name = decodedToken.city_name;
  const depo_name = decodedToken.depo_name;

  const { IND, filterdata, columnfilters } = props;
  const [loadedOption, setLoadedOption] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [disableInput, setDisableInput] = useState(false);
  const [disableInputValue, setDisableInputValue] = useState("");
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const appyData = (data) => {
    const res_result = data;
    const responce = [];
    if (res_result.length != 0) {
      if (props.cty_depo != undefined && city_name !== "") {
        let tmp_arr = []
        if (IND == "CITY_INDEX") {
          tmp_arr = city_name.split(",");
        } else {
          tmp_arr = depo_name.split(",");
        }
        if (tmp_arr.length == 1) {
          setDisableInput(true)
          setDisableInputValue(tmp_arr[0])
        }
        res_result.map((d, i) => {
          for (let j = 0; j < tmp_arr.length; j++) {
            if (tmp_arr[j] == d.key.column) {
              responce.push({ "id": d.key.column, "value": d.key.column, "label": d.key.column.toString() })
            }
          }
        })
      } else {
        res_result.map((d) => {
          responce.push({ "id": d.key.column, "value": d.key.column, "label": d.key.column.toString() })
        })
      }
    }
    setLoadedOption((preState) => [{ label: "All", value: "*" }, ...responce]);
    setSelectedOptions((preState) => [{ label: "All", value: "*" }, ...responce]);
  }



  useEffect(() => {
    if (props.changedColumn != IND) {
      fetchData({ url: API_URL_MAIN + "charging_api_bus", body: { IND, filterdata, columnfilters } }, appyData)
    }
  }, [props])



  function getDropdownButtonLabel({ placeholderButtonLabel, value }) {
    if (value && value.some((o) => o.value === "*")) {
      return `All`;
    } else {
      return `${value.length} selected`;
    }
  }

  function onChange(value, event) {
    if (event.action === "select-option" && event.option.value === "*") {
      this.setState(this.options);
      props.updateFilter(this.options, IND);
    } else if (
      event.action === "deselect-option" &&
      event.option.value === "*"
    ) {
      this.setState([]);
      props.updateFilter([], IND);
    } else if (event.action === "deselect-option") {
      const re = value.filter((o) => o.value !== "*");
      this.setState(re);
      props.updateFilter(re, IND);
    } else if (value.length === this.options.length - 1) {
      this.setState(this.options);
      props.updateFilter(this.options, IND);

    } else {
      this.setState(value);
      props.updateFilter(value, IND);
    }
  }

  return (
    <>
      {/* <div className="col-md-2 filter-col"> */}
      <span className="select_col_title_bus">{props.lable}</span>
      {(disableInput) ?
        <input autoComplete="off" className="top-filter filter-col" value={disableInputValue} disabled />
        :
        <ReactMultiSelectCheckboxes className="react-select-container" classNamePrefix="react-select"
          style={{ dropdownButton: { width: "100%" } }}
          options={[...loadedOption]}
          placeholderButtonLabel={props.lable}
          getDropdownButtonLabel={getDropdownButtonLabel}
          value={selectedOptions}
          onChange={onChange}
          setState={setSelectedOptions}
          disabled={true}
        />
      }
    </>
  )

}

export default CustomSelect_Bus;
